class Link {
  constructor(url, text) {
    this.url = url;
    this.text = text;
  }
}

export default Link;
